export default theme => ({
  root: {
    width: '100%',
    height: '90px',
    backgroundColor: theme.palette.common.white,
    boxShadow: '6.4px 6.4px 32px 0 rgba(154, 170, 176, 0.17)',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
  },
  logo: {
    width: '125px',
    height: '45px',
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    textDecoration: 'none',
    marginRight: '27px',
    color: '#2a149a',
    fontSize: '14px',
    fontFamily: 'Raleway',
    fontWeight: 'normal',
  },
  activeLink: {
    fontWeight: 'bold',
  },
  signOutButton: {
    marginLeft: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginLeft: '12px',
  },
});
